/**
 * Карточка показателя — docs/ui-design.md §7: label 11px CAPS muted → значение Geist 500
 * ~40px tabular-nums → дельта 12px tabular-nums. Классы `.kpi/.kpi-l/.kpi-v/.kpi-d` глобальные
 * (base.css), собственных размеров и цветов компонент не заводит.
 *
 * Главное здесь — различение нуля и «нечего показывать». `value === null` это НЕ ноль:
 * ноль значит «событий не было», null — «мерить пока нечем». В фазе 1 таблицы первых
 * прогонов пусты, и ноль, нарисованный на пустой выборке, читается как достижение
 * (08-alerts.md §7 и §12 требуют ровно обратного). Поэтому пустое значение — прочерк, а
 * `note` обязателен: пустая карточка без объяснения, чего ждём, бесполезна.
 *
 * Крупное число моноширинным не делаем никогда — правило v3 (ui-design §1, §3): числа несёт
 * Geist с `tabular-nums`, моноширинный остаётся на данных и мете, то есть на `.kpi-d`.
 */

import type { JSX } from 'react';

/** Тон подписи: рост, падение или нейтральный пояснительный текст. */
export type KpiTone = 'up' | 'down' | 'muted';

export interface KpiCardProps {
  readonly label: string;
  /** Готовая строка значения; `null` — данных нет, рисуется прочерк. */
  readonly value: string | null;
  /** Подпись под значением: единица, период или причина пустоты. Обязательна. */
  readonly note: string;
  readonly tone?: KpiTone;
}

export function KpiCard({ label, value, note, tone = 'muted' }: KpiCardProps): JSX.Element {
  const empty = value === null;
  return (
    <div className="kpi">
      <span className="kpi-l">{label}</span>
      <span className="kpi-v" style={empty ? { color: 'var(--muted)' } : undefined}>
        {empty ? '—' : value}
      </span>
      <span
        className={tone === 'muted' ? 'kpi-d' : `kpi-d ${tone}`}
        style={tone === 'muted' ? { color: 'var(--muted)' } : undefined}
      >
        {note}
      </span>
    </div>
  );
}
